import React from "react";

const colorFor = (v) => {
  if (v >= 9) return "#FF00FF";
  if (v >= 7) return "#FF003C";
  if (v >= 4) return "#FFEA00";
  return "#00FF00";
};

const labelFor = (v) => {
  if (v >= 10) return "NUCLEAR";
  if (v >= 9) return "UNHINGED";
  if (v >= 7) return "SEVERE";
  if (v >= 4) return "SPICY";
  return "MILD";
};

export const CringeMeter = ({ value = 1, testId }) => {
  const c = colorFor(value);
  const highCringe = value >= 8;
  return (
    <div className="w-full" data-testid={testId || `cringe-meter-${value}`}>
      <div className="flex items-center justify-between mb-1">
        <span className="font-mono text-[11px] uppercase tracking-widest text-white/80">
          CRINGE SCALE
        </span>
        <span
          className={`font-mono text-[11px] px-2 py-0.5 ${highCringe ? "vibrate" : ""}`}
          style={{ background: c, color: value >= 9 ? "#fff" : "#000" }}
        >
          {labelFor(value)} · {value}/10
        </span>
      </div>
      <div
        className="relative h-5 w-full bg-black border-2 border-white"
      >
        {[...Array(10)].map((_, i) => (
          <div
            key={i}
            className="absolute top-0 bottom-0 border-r border-white/40"
            style={{ left: `${(i + 1) * 10}%` }}
          />
        ))}
        <div
          className={`h-full ${highCringe ? "pulse-yellow" : ""}`}
          style={{
            width: `${(value / 10) * 100}%`,
            background: `repeating-linear-gradient(90deg, ${c} 0 10px, #000 10px 12px)`,
          }}
        />
      </div>
    </div>
  );
};
